import React from 'react';

import { Text } from '~/components/core';
import TextField from '~/components/core/Molecules/Fields/TextField';
import Switch from '~/components/ui/atoms/Switch';

interface DamageAssessmentTypesFilterProps {
  onSearchTermChanged: (term: string) => void;
  onShowOnlyEnabledChanged: (show: boolean) => void;
}

const DamageAssessmentTypesFilter: React.FC<DamageAssessmentTypesFilterProps> = ({
  onSearchTermChanged,
  onShowOnlyEnabledChanged,
}) => {
  return (
    <div className="my-20 grid grid-cols-3 gap-32">
      <TextField label="Search Damage Assessment Types" onChange={onSearchTermChanged} />
      <span className="flex items-center">
        <Switch onChange={(e) => onShowOnlyEnabledChanged(e.target.checked)} />{' '}
        <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
          Show only enabled
        </Text>
      </span>
    </div>
  );
};

export default DamageAssessmentTypesFilter;
